<template>
  <werecommend />
</template>

<script>
import Vue from 'vue'
import werecommend from '@/components/WerecommendHome.vue'

export default {
  name: 'WerecommendHome',
  components: {
    werecommend
  }
}
</script>
